import { Field } from 'react-final-form';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconAILabel } from '../../../../icon/IconAILabel';
import { FormControlLabel, LabelPlacement } from '../../../../input/FormControlLabel';
import { Switch } from '../../../../input/Switch';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { AILabelFiledProps } from './types';

export const AILabelFiled: React.FC<AILabelFiledProps> = ({ onChange }) => {
    const t = useTranslation();

    return (
        <Field
            type="checkbox"
            name="isAIContent"
            render={({ input }) => (
                <FormControlLabel
                    label={
                        <Flex
                            direction="row"
                            onClick={(e) => e.preventDefault()}
                            spacing={2}
                            alignItems="center"
                        >
                            <IconAILabel width={24} height={24} />
                            <Flex>
                                <Typography variant="body" color="primary">
                                    {t('Контент, созданный с помощью ИИ')}
                                </Typography>
                                <Typography variant="caption" color="secondary">
                                    {t(
                                        'Отметьте, если ваш контент сгенерирован с использованием / с помощью ИИ',
                                    )}
                                </Typography>
                            </Flex>
                        </Flex>
                    }
                    control={
                        <Switch
                            {...input}
                            onChange={(event) => {
                                input.onChange(event);
                                onChange?.(event);
                            }}
                        />
                    }
                    labelPlacement={LabelPlacement.LEFT}
                />
            )}
        />
    );
};
